module.exports = __webpack_public_path__ + "static/img/边框9.85a3fa2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边框9.svg
// module id = Wf+l
// module chunks = 2